<div #dropdown class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="alertsDropdown">
    <h6 class="dropdown-header">
        {{isDefault ? ('common.default.airport' | translate) : ('entity.airport.name' | translate)}}
    </h6>
    <form [formGroup]="form" autocomplete="off" onkeydown="return event.key != 'Enter';">
        <!-- <div class="input-group"> -->
            <input type="text" required #airportIataCode 
                formControlName="airportIataCode" class="form-control" list="airportIataCodeDataList"
                appInputList
                placeholder="{{'common.entity.iataCode' | translate}}" data-size="3" autocomplete="off"
                (keydown.space)="$event.preventDefault();"
                (change)="changeAirport($event.target.value)"
                appUpperCase
            />
            <app-coordinated-airport-data-list appId="airportIataCodeDataList" appInputId="airportIataCode" appMulti="true">
            </app-coordinated-airport-data-list>
            
            <!-- <div class="input-group-prepend">
                <button type="submit" class="btn btn-primary btn-sm btn-input-group input-group-text" title="Ok" tabindex="-1" [disabled]="!form.valid">
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
        </div> -->
        <!-- <app-form-error [form]="form" controlName="airportIataCodeDataList" [notExists]="true" [required]="true" format="aaa"></app-form-error>         -->
    </form>

</div>

